export const perPageOptions: number [] = [10, 25, 50, 100]